import { render } from "./Home.vue?vue&type=template&id=dcf08b6e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dcf08b6e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dcf08b6e"

export default script